import styled from 'styled-components';

interface TextProps {
  mobile?: boolean;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
`;

const Title = styled.h3<TextProps>`
  font-size: ${({ theme, mobile }) => (mobile ? theme.fontSize.sm : theme.fontSize.lg)};
  font-weight: 700;
  text-align: center;
  text-transform: ${({ theme }) => theme.titleTransform};
  color: #575757;
`;

const SubTitle = styled.p<TextProps>`
  font-size: ${({ theme, mobile }) => (mobile ? theme.fontSize.xs : theme.fontSize.sm)};
  text-transform: none;
  text-align: center;
  margin-top: 1px;
  font-weight: 400;
  color: #575757;
  margin: 18px 0;
`;

const Button = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: 700;
  line-height: 100%;
  text-transform: ${({ theme }) => theme.btnTextTransform};
  color: ${({ theme }) => theme.white};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.primaryColor};
  background-color: ${({ theme }) => theme.primaryColor};
  height: 45px;
  width: 20%;
  margin-top: 10px;

  &:hover {
    color: ${({ theme }) => theme.white};
  }
`;

export { Wrapper, Title, SubTitle, Button };
